var Theme = Theme || {};

Theme.FreshChat = (function ($) {

    return {
        init: _init
    };

    function _init() {

        var $input = $('.js-fresh-chat-input');

        if ($input.length) {
            
            SCM.Retry.policy()
                .handleResult(function (result) { return !result; })
                .waitAndRetry(3, 500) // Retry 3 times, waiting 500ms between each try
                .execute(function () {
                    return window.fcWidget; // Check if FreshChat is ready
                })
                .then(function (result) {
                    _initializeFreshChat($input); // Initialize FreshChat after it's ready
                })
                .catch(function (reason) {
                    console.error('Timed out waiting for FreshChat to be ready.');
                });
            
        }
    }
    
    function _initializeFreshChat($freshChatInput) {
        
        if ($freshChatInput.length) {
            
            var token = $freshChatInput.data('fresh-chat-token');

            window.fcWidget.init( { 
                    token: token, 
                    host: "https://wchat.freshchat.com" 
                }
            );
        }
    }

})(jQuery);

